<template>
  <v-sheet>
    <autocomplete-multiple v-if="typeof single==='undefined'" class="mb-0" name="Организации" :items="items" :select.sync="selected" @load="load()" :loading="state.isLoading" v-bind="typeof selectAllEnabled !== 'undefined' ? { selectAllEnabled } : {}">
      <template v-slot:itemInfo="{ item }">
        <div class="caption">
          <span v-if="item.oms">(ОМС)</span>
          <span v-if="item.dms">(ДМС)</span>
          <span v-if="item.contract">(Контракт)</span>
        </div>
      </template>
    </autocomplete-multiple>
    <autocomplete-single v-else name="Организация" class="mb-0" :items="items" :select.sync="selected" @load="load()" :loading="state.isLoading">
      <template v-slot:itemInfo="{ item }">
        <div class="caption">
          <span v-if="item.oms">(ОМС)</span>
          <span v-if="item.dms">(ДМС)</span>
          <span v-if="item.contract">(Контракт)</span>
        </div>
      </template>
    </autocomplete-single>
  </v-sheet>
</template>

<script>

import State from "@/plugins/state";
import moment from "moment/moment";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import {
  Entity_Insur
} from "../../../../EntityStoreCacheService";

export default {
  components: {AutocompleteMultiple, AutocompleteSingle},
  props:['selectedItems', 'type', 'single', 'onlyRelevant', 'selectAllEnabled'],
  data:()=>({
    selected:null,
    items:[],
    text:null,
    state: new State(),
  }),
  watch:{
    selected(){
      console.log('Selected')
      if(Array.isArray(this.selected)){
        this.$emit('selected', this.selected);
      } else {
        this.$emit('selected', this.selected===null ? null : this.selected);
      }
    }
  },
  mounted() {
    if (this.selectedItems !== undefined)
      this.load()
  },
  methods:{
    load(){
      if(this.items.length===0) {
        this.state.stateLoading();
        let rb = new Entity_Insur()
          .selects(Entity_Insur.id)
          .selects(Entity_Insur.name)
          .selects(Entity_Insur.oms)
          .selects(Entity_Insur.dms)
          .selects(Entity_Insur.contract)

        if(typeof this.type!=='undefined')
          rb.filterAnd([Entity_Insur.entity, Entity_Insur[this.type]].join('.')+' = TRUE');

        if(this.onlyRelevant!==undefined)
          rb.filterAnd([Entity_Insur.entity, Entity_Insur.end].join('.')+'>=?',moment().format('YYYY-MM-DD 23:59:59'));

        rb.page(1).onPage(1000)
        .addStateCallback((v)=> this.state.setRequestBuilderState(v))
        .request((v)=>{
            this.items = v.items;

            //если есть предзагруженные данные
            if (this.items.length>0&&this.selectedItems !== undefined) {
              //если уже есть выбранные данные, а договор по страховой просрочен
              if(Array.isArray(this.selectedItems)){                
                this.selectedItems.forEach(i=>{
                  if (!this.items.some(item => item.id==i.d))
                    this.items.push(i);
                })
              } else if (!this.items.some(i=>i.id === this.selectedItems.id)){
                  this.items.push(this.selectedItems);
              }

              this.selected = this.selectedItems
            }
                
        }, (e)=>{
          console.error(e.response.data.message);
          this.state.stateError(e)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .insure-item {
    position: relative;
    width: 100%;
    &__text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 150px;
    }
    &__label {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
</style>